export default __webpack_public_path__ + "static/stickyNote-046eaa8c893ddc7f38f8c69679748de8.jpeg";